import {
  Row,
  Input,
  Button,
  Table,
  Popover,
  Form,
  Col,
  DatePicker,
  Select,
  message,
  Tooltip,
} from "antd";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import exportCSV from "assets/icons/exportcsv.svg";

import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import review from "assets/icons/review.svg";
import { Link } from "react-router-dom";
import { CSVLink } from "react-csv";
import { satisfactionLevels, typeOfCare } from "utility/constant";
import { ListRewardSubmissions } from "utility/action";
import editIcon from "assets/icons/edit.svg";
import search from "utility/search";
import { CheckOutlined } from "@ant-design/icons";
import TableSkeleton from "utility/TableSkeleton";

export default function OpenEob() {
  const [eob, setEOB] = useState([]);
  const [loading, setLoading] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [dataSource, setDataSource] = useState(eob);
  const [searchloading, setSearchLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const setEobRow = function (row) {
    return {
      key: row?.id,
      searchByName: row?.searchByName,
      Action: row?.id,
      Name: row?.name,
      Email: row?.customerEmail,
      DateSubmitted: row?.dateSubmitted
        ? moment(row?.dateSubmitted).format("YYYY-MM-DD")
        : "-",
      TypeOfCare: row?.typeOfCare,
      Procedure: row?.nameOfProcedure,
      feedback: row?.feedback,
    };
  };

  const fetchReward = useCallback(async () => {
    try {
      setLoading(true);
      const filter = {
        status: { eq: "PENDING" },
      };
      const response = await ListRewardSubmissions(filter);
      const data = response.map((row) => setEobRow(row));
      data.sort(
        (a, b) => new Date(b.DateSubmitted) - new Date(a.DateSubmitted)
      );
      setEOB(data);
      setDataSource(data);
      setCsvData(response);
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Something went wrong",
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchReward();
  }, [fetchReward]);

  const handleSearch = async (e) => {
    const currValue = e.target.value.trim();
    const searchFields = [
      "Name",
      "Email",
      "DateSubmitted",
      "Procedure",
      "TypeOfCare",
    ];
    const filteredData = search(eob, currValue, searchFields);
    setDataSource(filteredData);
  };

  const handleAdvanceSearch = async (value) => {
    setSearchLoading(true);
    let filter = {};
    if (value.Name) filter = { ...filter, name: { contains: value.Name } };
    if (value.DateSubmitted)
      filter = {
        ...filter,
        dateSubmitted: {
          contains: moment(value.DateSubmitted).format("YYYY-MM-DD"),
        },
      };
    if (value.toc) filter = { ...filter, typeOfCare: { contains: value.toc } };
    filter = { ...filter, status: { eq: "PENDING" } };

    let variables = {};
    if (Object.keys(filter).length !== 0) variables = { and: [filter] };

    await ListRewardSubmissions(variables)
      .then((response) => {
        const eobData = response.map((row) => setEobRow(row));
        eobData.sort(
          (a, b) => new Date(b.DateSubmitted) - new Date(a.DateSubmitted)
        );
        setDataSource(eobData);
      })
      .catch((error) => {
        console.log(error);
        setSearchLoading(false);
      });
    setSearchLoading(false);
  };

  const headers = [
    { label: "Reward For", key: "rewardFor" },
    { label: "Name", key: "name" },
    { label: "DOB", key: "dob" },
    { label: "Type of care", key: "typeOfCare" },
    { label: "Name Of Procedure", key: "nameOfProcedure" },
    { label: "Claim Number", key: "claimNumber" },
    { label: "Status", key: "status" },
    { label: "Documents", key: "uploadedImages" },
  ];

  const data = csvData.map((row) => ({
    rewardFor: row?.rewardFor,
    name: row?.name,
    dob: row?.dob,
    typeOfCare: row?.typeOfCare,
    nameOfProcedure: row?.nameOfProcedure,
    claimNumber: row?.claimNumber,
    status: row?.status,
    uploadedImages: row?.uploadedImages,
  }));

  // Define the mapping of values to satisfaction levels
  const valueToSatisfactionMapping = {
    0: [0],
    1: [0, 1],
    2: [0, 1, 2],
    3: [0, 1, 2, 3],
    4: [0, 1, 2, 3, 4],
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
    },
    {
      title: "Email",
      dataIndex: "Email",
    },
    {
      title: "Date Submitted",
      dataIndex: "DateSubmitted",
    },
    {
      title: "Procedure",
      dataIndex: "Procedure",
    },
    {
      title: "Type Of Care",
      dataIndex: "TypeOfCare",
    },
    {
      title: "",
      dataIndex: "feedback",
      render: (data, records) => {
        const rating = records?.feedback?.rating;
        let filteredSatisfactionLevels;
        let message = "";

        if (rating !== null && valueToSatisfactionMapping[rating]) {
          filteredSatisfactionLevels = satisfactionLevels.filter(
            (level, index) => valueToSatisfactionMapping[rating].includes(index)
          );

          if (rating >= 0 && rating <= 1) {
            message = "Very dissatisfied";
          } else if (rating > 1 && rating <= 3) {
            message = "Partially satisfied";
          } else if (rating === 4) {
            message = "Very satisfied";
          }
        } else {
          filteredSatisfactionLevels = [];
        }

        return (
          <>
            {records?.feedback?.rating ? (
              <Tooltip
                placement="bottomRight"
                overlayClassName="review-card"
                color="#fff"
                title={
                  records?.feedback ? (
                    <Row>
                      <Col md={24} span={24} xs={24}>
                        <Row>
                          {filteredSatisfactionLevels?.map((level, index) => (
                            <>
                              <div
                                key={index}
                                className={`equal-width-div ${
                                  rating === index ? "selected" : ""
                                }`}
                                style={{
                                  background: level.background,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: "16px",
                                  width: "53px",
                                  marginLeft: "5px",
                                  padding: "10px",
                                  fontWeight: "500",
                                }}
                              >
                                {rating === index ? (
                                  <CheckOutlined />
                                ) : (
                                  level.text
                                )}
                              </div>
                            </>
                          ))}
                        </Row>
                      </Col>
                      <Col md={24} span={24} xs={24}>
                        <p className="feedback-comment mt-10">{message}</p>
                      </Col>
                      <Col md={24} span={24} xs={24}>
                        <p className="feedback-review mt-10">
                          {records?.feedback?.comment}
                        </p>
                      </Col>
                    </Row>
                  ) : (
                    <Col md={24} span={24} xs={24}>
                      <p className="feedback-comment">No Feedback</p>
                    </Col>
                  )
                }
              >
                <img src={review} alt="" />
              </Tooltip>
            ) : (
              ""
            )}
          </>
        );
      },
    },

    {
      title: "",
      dataIndex: "Action",
      className: "actions",
      render: (id) => {
        return (
          <Link to="/open-eob-detail" state={{ id: id }}>
            <img src={editIcon} alt="" />
          </Link>
        );
      },
    },
  ];

  const uniqueName = Array.from(new Set(eob.map((item) => item.Name)));

  const content = (
    <div className="update-form popover-form">
      <Form layout="vertical" onFinish={handleAdvanceSearch}>
        <Row justify="center" align="middle" gutter={[20, 30]}>
          <Col>
            <Form.Item label="Name" name="Name">
              <Select
                allowClear
                placeholder="Select name"
                style={{ width: 200 }}
                getPopupContainer={(trigger) => trigger.parentNode}
              >
                {uniqueName.map((item, index) => (
                  <Select.Option
                    key={index}
                    value={item}
                  >{`${item}`}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col>
            <Form.Item label="Date submitted" name="DateSubmitted">
              <DatePicker
                style={{ width: "100%" }}
                disabledDate={(d) => !d || d.isAfter(new Date())}
              />
            </Form.Item>
          </Col>
          <Col span={4} md={6} sm={24} xs={24}>
            <Form.Item label="Type of care" name="toc">
              <Select
                allowClear
                placeholder="Select type of care"
                options={typeOfCare}
                style={{ width: 150 }}
                getPopupContainer={(trigger) => trigger.parentNode}
              ></Select>
            </Form.Item>
          </Col>

          <Col>
            <Row
              justify="start"
              align="middle"
              style={{ height: "100%", paddingTop: 5 }}
            >
              <Button className="blue-btn" htmlType="submit">
                Search
              </Button>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );

  return (
    <>
      {contextHolder}
      <Row justify="space-between table-header">
        <Row align="middle">
          <Input
            prefix={<SearchOutlined />}
            placeholder="Search"
            className="searchbar"
            onChange={handleSearch}
            style={{ width: 250 }}
          />
        </Row>

        <Row className="gap-10 mtr-20">
          <Popover
            trigger="click"
            content={content}
            title=""
            placement="topRight"
            color="#F2F9FD"
          >
            <Button className="blue-border-btn inherit-btn">
              Advance search
              <DownOutlined />
            </Button>
          </Popover>
          <CSVLink
            data={data}
            headers={headers}
            filename={"Open EOB.csv"}
            className="export-btn"
          >
            <img src={exportCSV} alt="" className="action-icons" />
          </CSVLink>
        </Row>
      </Row>

      {loading || searchloading ? (
        <TableSkeleton />
      ) : (
        <Table
          columns={columns}
          dataSource={dataSource}
          className="common-table"
          scroll={{ x: 992 }}
          pagination={{ position: ["", "bottomCenter"] }}
        />
      )}
    </>
  );
}
